import   React                    , 
       { useEffect                ,
	     useRef                   }  from 'react';

import { useNavigate              }  from 'react-router-dom';

import { Dispatch                 }  from 'redux';
import { useDispatch              }  from 'react-redux';
	   
import   ReactPlayer                 from 'react-player/lazy'

import   classNames                  from 'classnames';
import   screenfull                  from 'screenfull';

import { format                   }  from 'date-fns';

import   styles                      from './viewer.module.scss';

import { WWW_URLS                 }  from '../../../network/urls';

import { setCurrentlyPlayingVideo }  from '../../../datas/videoManagment/actionCreators';

import { useTypedSelector         }  from '../../../datas/useTypeSelector';

import { postViewerNotification   }  from '../../../network/api_video';

import { postEvent                   }  from '../../../network/api_events_stats';


export const VideoViewer = () => {

  const navigate = useNavigate();
  const dispatch: Dispatch<any> = useDispatch();

  const { currentlyPlayingVideo } = useTypedSelector ( (state) => state.videoManagment );
  const { authentication }        = useTypedSelector((state) => state.authenticationManagment );

  let progressCount = 0;

  const playerRef       = useRef<ReactPlayer>(null);
  const startingDateRef = useRef<string>("");

  var urlVideo: string|null = null;
  
  if ( typeof ( currentlyPlayingVideo.video ) !== 'undefined' )
   {
    if ( currentlyPlayingVideo.video !== null )
	 {
      urlVideo = `${WWW_URLS.Video}${currentlyPlayingVideo.video.videoFile}/index.m3u8`;
     }
   }
   
  useEffect(() => {

    window.scroll(0, 0);

	postEvent ( "__OPEN__:" + window.location.pathname + window.location.search + window.location.hash + ':' + urlVideo, authentication.login )
	
    if (screenfull.isEnabled) 
	      {
	       console.log ("Mode fullscreen automatique autorisé");
		   
		   const element = document.querySelector('#viewer');

           if (element) 
		         {
                  screenfull.request(element).catch((err) => {
        
		            console.error('Error attempting to enable fullscreen mode:', err);
                  });
                 } 
		    else {
                  console.error('Element #viewer not found');
                 }

          }
	 else {
	       console.log ("Mode fullscreen automatique non autorisé");
	      }
  }, []);
  
 
  const handleClick = () => {
   
    let currentTime: number = 0;
    let duration:    number = 0;
  
    if (playerRef.current)  
	 {
      currentTime = playerRef.current.getCurrentTime ();
      duration    = playerRef.current.getDuration    ();
     }
	
    if ( currentlyPlayingVideo !== null )
	 {
      if ( currentlyPlayingVideo.video !== null )
	   {
        const eventMessage: string = `VideoViewer-Bouton01:"Retour":${currentlyPlayingVideo.video.id}:${startingDateRef.current}:${currentTime}:${duration}`

        postEvent ( "__CLICK__:" + window.location.pathname + window.location.search + window.location.hash + ':' + eventMessage , authentication.login )

        postEvent ( "__STOP__:" + window.location.pathname + window.location.search + window.location.hash , authentication.login )

	    postViewerNotification ( currentlyPlayingVideo.video.id ,
		     					 `onBackButtonClick:${startingDateRef.current}` ,
			    				 currentTime                    ,
				    			 duration                       ,
								 authentication.login           )
       }
	 }
	 
	dispatch ( setCurrentlyPlayingVideo ( null ) );

    navigate(-1)
  }
  
  const handleStart = () => {

    const startingDateStr = format ( new Date (), 'yyyy-MM-dd HH-mm-ss')

    startingDateRef.current = startingDateStr;  // Mettre à jour la référence

    let currentTime: number = 0;
    let duration:    number = 0;
  
    if (playerRef.current)  
	 {
      currentTime = playerRef.current.getCurrentTime ();
      duration    = playerRef.current.getDuration    ();
     }
	  
    if ( currentlyPlayingVideo !== null )
	 {
      if ( currentlyPlayingVideo.video !== null )
	   {
        const eventMessage: string = `VideoViewer-onStart:${currentlyPlayingVideo.video.id}:${startingDateStr}:${currentTime}:${duration}`

        postEvent ( "__START_VIDEO__:" + window.location.pathname + window.location.search + window.location.hash + ':' + eventMessage , authentication.login )

	    postViewerNotification ( currentlyPlayingVideo.video.id ,
		    					 `onStart:${startingDateStr}`   ,
			    				 currentTime                    ,
				    			 duration                       ,
								 authentication.login           )
       }
	 }
  }

  const handleEnded = () => {
 
    let currentTime: number = 0;
    let duration:    number = 0;
  
    if (playerRef.current)  
	 {
      currentTime = playerRef.current.getCurrentTime ();
      duration    = playerRef.current.getDuration    ();
     }
	  
    if ( currentlyPlayingVideo !== null )
	 {
      if ( currentlyPlayingVideo.video !== null )
	   {
        const eventMessage: string = `VideoViewer-onEnded:${currentlyPlayingVideo.video.id}:${startingDateRef.current}:${currentTime}:${duration}`

        postEvent ( "__END_VIDEO__:" + window.location.pathname + window.location.search + window.location.hash + ':' + eventMessage , authentication.login )

	    postViewerNotification ( currentlyPlayingVideo.video.id       ,
		    					 `onEnded:${startingDateRef.current}` ,
			    				 currentTime                          ,
				    			 duration                             ,
								 authentication.login                 )
       }
	 }
  }

  const handlePlay = () => {
  
    let currentTime: number = 0;
    let duration:    number = 0;
  
    if (playerRef.current)  
	 {
      currentTime = playerRef.current.getCurrentTime ();
      duration    = playerRef.current.getDuration    ();
     }

    if ( currentlyPlayingVideo !== null )
	 {
      if ( currentlyPlayingVideo.video !== null )
	   {
        const eventMessage: string = `VideoViewer-onPlay:${currentlyPlayingVideo.video.id}:${startingDateRef.current}:${currentTime}:${duration}`

        postEvent ( "__PLAY_VIDEO__:" + window.location.pathname + window.location.search + window.location.hash + ':' + eventMessage , authentication.login )
	  
    	postViewerNotification ( currentlyPlayingVideo.video.id      ,
	    						 `onPlay:${startingDateRef.current}` ,
		    					 currentTime                         ,
			    				 duration                            ,
								 authentication.login                )
       }
	 }
  }
  
  const handlePause = () => {
  
    let currentTime: number = 0;
    let duration:    number = 0;
  
    if (playerRef.current)  
	 {
      currentTime = playerRef.current.getCurrentTime ();
      duration    = playerRef.current.getDuration    ();
     }
	  
    if ( currentlyPlayingVideo !== null )
	 {
      if ( currentlyPlayingVideo.video !== null )
	   {
        const eventMessage: string = `VideoViewer-onPause:${currentlyPlayingVideo.video.id}:${startingDateRef.current}:${currentTime}:${duration}`

        postEvent ( "__PAUSE_VIDEO__:" + window.location.pathname + window.location.search + window.location.hash + ':' + eventMessage , authentication.login )

	    postViewerNotification ( currentlyPlayingVideo.video.id       ,
		    					 `onPause:${startingDateRef.current}` ,
			    				 currentTime                          ,
				    			 duration                             ,
								 authentication.login                 )
       }
	 }
  }
  
  const handleProgress = (state: { played: number; playedSeconds: number }) => {

    let currentTime: number = 0;
    let duration:    number = 0;

    if (playerRef.current)
	 {
      currentTime = playerRef.current.getCurrentTime ();
      duration    = playerRef.current.getDuration    ();
     }

    if ( currentlyPlayingVideo !== null )
	 {
      if ( currentlyPlayingVideo.video !== null )
	   {
        if ( progressCount < 60 )
              {
               progressCount++;
              }
         else {
               progressCount = 0;

               const eventMessage: string = `VideoViewer-onProgress:${currentlyPlayingVideo.video.id}:${startingDateRef.current}:${currentTime}:${duration}:${state.playedSeconds}:${state.played}`

               postEvent ( "__HEART_BEAT_VIDEO__:" + window.location.pathname + window.location.search + window.location.hash + ':' + eventMessage , authentication.login )

               postViewerNotification ( currentlyPlayingVideo.video.id                                                 ,
	   	    	   			            `onProgress:${startingDateRef.current}:${state.playedSeconds}:${state.played}` ,
                                        currentTime                                                                    ,
				    		            duration                                                                       ,
							            authentication.login                                                           )
              }
       }
	 }
  };
  
  const handleSeek = (seconds: number) => {
  
    let currentTime: number = 0;
    let duration:    number = 0;
  
    if (playerRef.current)  
	 {
      currentTime = playerRef.current.getCurrentTime ();
      duration    = playerRef.current.getDuration    ();
     }
	  
    if ( currentlyPlayingVideo !== null )
	 {
      if ( currentlyPlayingVideo.video !== null )
	   {
        const eventMessage: string = `VideoViewer-onSeek:${currentlyPlayingVideo.video.id}:${startingDateRef.current}:${currentTime}:${duration}:${seconds}`

        postEvent ( "__SEEK_VIDEO__:" + window.location.pathname + window.location.search + window.location.hash + ':' + eventMessage , authentication.login )

	    postViewerNotification ( currentlyPlayingVideo.video.id                 ,
		    					 `onSeek:${startingDateRef.current}:${seconds}` ,
			    				 currentTime                                    ,
				    			 duration                                       ,
								 authentication.login                           )
       }
	 }
  };

  return (
 
    <div id="viewer" className = {classNames(styles.root)} >

      <div className = {classNames(styles.back_button)} >

        <button onClick={handleClick}>Retour</button>

      </div>

      { 
	    (urlVideo !== null) 
		&&
        (
		 <ReactPlayer ref        = {playerRef}
                      url        = {urlVideo}
                      className  = {classNames(styles.player)}
                      controls   = {true}
                      playing    = {true}
                      width      = '100%'
                      height     = '100%' 
					  onStart    = {handleStart}
					  onEnded    = {handleEnded}
					  onPlay     = {handlePlay}
					  onPause    = {handlePause}
					  onProgress = {handleProgress} 
					  onSeek     = {handleSeek} />
        )
      }
	  
	</div>
 
  );
  
};

export default VideoViewer;

